import { datadogRum } from '@datadog/browser-rum';
import axios from 'axios';

export const initializeDatadogRum = () => {
  if (!window.datadogConfig || !window.datadogConfig.dd_rum_client_token) {
    // eslint-disable-next-line no-console
    console.warn(
      'Datadog RUM is not configured. Skipping initialization.',
      window.datadogConfig
    );
    return;
  }

  datadogRum.init({
    applicationId: window.datadogConfig.dd_rum_application_id,
    clientToken: window.datadogConfig.dd_rum_client_token,
    // `site` refers to the Datadog site parameter of your organization
    // see https://docs.datadoghq.com/getting_started/site/
    site: 'datadoghq.com',
    service: 'chatwoot-saas-browser',
    env: window.datadogConfig.dd_env || 'development',
    version: window.datadogConfig.dd_version || '1.0.0',

    // 🔪 corta custo e ruído
    sessionSampleRate: 100,
    sessionReplaySampleRate: 0, // replay OFF
    trackResources: false,
    trackLongTasks: true,
    trackUserInteractions: false,

    // opcional, mas ajuda no GDPR sem dor
    defaultPrivacyLevel: 'mask-user-input',
  });

  datadogRum.setGlobalContextProperty(
    'instance_id',
    window.datadogConfig.instance_id
  );

  axios.interceptors.response.use(
    response => response,
    error => {
      if (error.isAxiosError && error.response === undefined) {
        datadogRum.addError(error, {
          message: error.message,
          url: error.config.url,
          method: error.config.method,
        });
      }
      return Promise.reject(error);
    }
  );

  datadogRum.startSessionReplayRecording();
};

export const setDatadogRumUser = user => {
  if (!window.datadogConfig || !window.datadogConfig.dd_rum_client_token) {
    // eslint-disable-next-line no-console
    console.warn(
      'Datadog RUM is not configured. Skipping user set.',
      window.datadogConfig
    );
    return;
  }
  datadogRum.setUser({
    id: user.pubsub_token,
    pubsub_token: user.pubsub_token,
    name: user.name,
    email: user.email,
    type: user.type,
    role: user.role,
    account_id: user.account_id,
  });
};
